import { render, staticRenderFns } from "./RestaurantMenu.vue?vue&type=template&id=66187c3f&lang=pug&"
import script from "./RestaurantMenu.vue?vue&type=script&lang=js&"
export * from "./RestaurantMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports